import { render } from "./UserDelete.vue?vue&type=template&id=1b8a7d9f&scoped=true"
import script from "./UserDelete.vue?vue&type=script&lang=js"
export * from "./UserDelete.vue?vue&type=script&lang=js"

import "./UserDelete.vue?vue&type=style&index=0&id=1b8a7d9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8a7d9f"],['__file',"resources/js/components/User/UserDelete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b8a7d9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b8a7d9f', __exports__)) {
    api.reload('1b8a7d9f', __exports__)
  }
  
  module.hot.accept("./UserDelete.vue?vue&type=template&id=1b8a7d9f&scoped=true", () => {
    api.rerender('1b8a7d9f', render)
  })

}


export default __exports__